import React from 'react';
import { logError } from './../services/shared';
import FallbackError from './fallbackError';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false,
      errorInfo: ''
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }
  
  async componentDidCatch(error, errorInfo) {
    let additionalHeaders= {
      hosttoken: this.props.hosttoken
    }
    let logData= {
      level: 'error',
      error: error.toString(),
      errorInfo: errorInfo.componentStack
    }
    try{
      this.setState({ errorInfo });
      await logError(additionalHeaders,logData);
    }catch(e){
      console.log(e);
    }
    
  }
  
  render() {
    const { hasError} = this.state;
    if(hasError){
      return (
        <div className="card my-5">
          <div className="card-header">
            <p style={{margin:0}}>
              <FallbackError {...this.props} hasError ={this.hasError} errorInfo={this.state.errorInfo}/>
            </p>
          </div>
        </div>
      )
    }
    return this.props.children;
  }  
}
export default ErrorBoundary;